<template>
  <article class="login form">
    <v-row align="center" class="login-content form-content">
      <v-row justify="center" align="center" style="flex-direction: column">
        <v-btn
          class="mb-4"
          color="blue lighten-4"
          depressed
          @click="goBack"
          fab
        >
          <v-icon dark>mdi-arrow-left</v-icon>
        </v-btn>
        <v-col cols="4" class="login__content form__content">
          <v-form
            ref="form"
          >
            <h1 class="login__title form__title">사용자등록</h1>
            <v-text-field
              v-model="email"
              label="이메일"
              required
            ></v-text-field>
            <v-text-field
              v-model="name"
              label="이름"
              required
            ></v-text-field>
            <v-text-field
              v-model="phone"
              label="연락처"
              required
            ></v-text-field>
            <v-text-field
              v-model="password"
              type="password"
              name="input-10-2"
              label="비밀번호"
            ></v-text-field>
            <v-text-field
              v-model="passwordConfirm"
              type="password"
              name="input-10-2"
              label="비밀번호확인"
            ></v-text-field>
            <v-btn
              block
              :disabled="!(email&&name&&password&&phone&&passwordConfirm)"
              color="primary"
              class="mt-4"
              tile
              depressed
              @click="onSubmit"
              x-large
            >
              사용자 등록
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-row>
  </article>
</template>
<script>
import sha256 from 'crypto-js/sha256'
import { user } from '../api'
import principal from '../utils/principal'
import eventBus from '../utils/eventBus'

export default {
  components: {
  },
  data: () => ({
    email: '',
    password: '',
    passwordConfirm: '',
    name: '',
    phone: null
  }),
  methods: {
    async onSubmit () {
      if (!this.email.trim()) {
        eventBus.$emit('alert', { active: true, text: '이메일을 입력해 주세요', type: 'error' })
        return
      }
      if (!this.name.trim()) {
        eventBus.$emit('alert', { active: true, text: '이름을 입력해 주세요', type: 'error' })
        return
      }
      if (!this.phone.trim()) {
        eventBus.$emit('alert', { active: true, text: '연락처를 입력해 주세요', type: 'error' })
      }
      if (!this.password.trim()) {
        eventBus.$emit('alert', { active: true, text: '비밀번호를 입력해 주세요', type: 'error' })
        return
      }
      if (this.password !== this.passwordConfirm) {
        eventBus.$emit('alert', { active: true, text: '비밀번호 확인값이 다릅니다. 다시한번 확인해 주세요', type: 'error' })
        return
      }

      const { data } = await user.signUp({
        email: this.email,
        name: this.name,
        phone: this.phone,
        saved: sha256(this.password).toString()
      })
      principal.storePrincipal(data.token)
      eventBus.$emit('dialog',
        {
          active: true,
          msgTitle: '계정이 생성되었습니다.',
          msg: '계정 관리 담당자가 관리할 항목 권한을 허락해야합니다.<br/> (계정 생성 직후에는 아무런 권한이 없습니다.)',
          okText: '메인페이지로 이동',
          isChoice: false,
          confirmHandler: {
            ok: () => {
              this.goMain()
            }
          }
        }
      )
    },
    goMain () {
      this.$router.push('/admin')
    },
    goBack () {
      this.$router.push('/admin/login')
    }
  }
}
</script>
<style scoped lang="scss">
@import "../assets/style/style";
@include form-content;
</style>
